import React from 'react';

const AppContext = React.createContext();

const AppProvider = ({ children, isTouch }) => (
    <AppContext.Provider value={{ isTouch }}>
        {children}
    </AppContext.Provider>
);

export {
    AppProvider,
    AppContext
};
